import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { MenuItemComponentType } from "../../../../../constants";
import { MenuActionCreators } from "../../../../../redux/action-creators";
import { MenuSelectors } from "../../../../../redux/selectors";
import { useSpectateCategoryItemsWithFavorites } from "./useSpectateCategoryItemsWithFavorites";
import { TrackingInfo } from "../../../../tracking/TrackingInfoMenu";

export const useSpectateMenuItemsMobile = () => {
  const { hiddenCategories, visibleCategories } =
    useSpectateCategoryItemsWithFavorites();

  const menuItems = useSelector(MenuSelectors.menuItems);
  const dispatch = useDispatch();

  useEffect(() => {
    const handleMenuItemClick = () => {
      dispatch(MenuActionCreators.hideHamburgerMenu());
    };

    const quickLinkItems = getMobileSpectateMenuItems(
      visibleCategories,
      hiddenCategories,
      handleMenuItemClick
    );

    if (quickLinkItems && quickLinkItems.length) {
      dispatch(MenuActionCreators.setMenuItems(quickLinkItems));
    }
  }, [dispatch, visibleCategories, hiddenCategories]);

  return menuItems;
};

const getMobileSpectateMenuItems = (
  menuCategories,
  hiddenCategories,
  handleMenuItemClick
) => {
  const categories = menuCategories.slice();
  if (hiddenCategories.length) {
    categories.push(hiddenCategories[hiddenCategories.length - 1]);
  }

  const quickLinkItems = [];
  categories.forEach((item, idx) => {
    const hasChildren = item.items?.length > 0;
    const componentType = hasChildren
      ? MenuItemComponentType.ExpandableSportCategoryMenuItemMobile
      : MenuItemComponentType.SportCategoryMenuItem;

    const isLastItem = idx === categories.length - 1;
    const menuItem = {
      key: `menu-item-${item.fullURL}-${item.ID || item.sportID}`,
      props: {
        item,
        dataTestId: isLastItem ? "all-sports" : item.termKey,
        trackingInfo: TrackingInfo,
        onClick: (!hasChildren && handleMenuItemClick) || undefined,
        hasArrow: hasChildren
      },
      componentType
    };

    quickLinkItems.push(menuItem);
  });

  return quickLinkItems;
};
